import 'css-chunksrc/client/scenes/resourceDetailsConfiguration/form/columns/styles.scss';export default {
  "columns": "_columns_1rpqg_1",
  "columnWrapper": "_columnWrapper_1rpqg_7",
  "column": "_column_1rpqg_1",
  "iconBox": "_iconBox_1rpqg_27",
  "icon": "_icon_1rpqg_27",
  "columnIcon": "_columnIcon_1rpqg_45",
  "hidden": "_hidden_1rpqg_54"
};